// @mui material components
import Grid from "@mui/material/Grid";

// Ajce Hostel App React components
import MDBox from "components/MDBox";


// Ajce Hostel App React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import EditStudentForm from "./components/EditStudentForm";

function EditStudents() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
         <MDBox p={5}>
            <EditStudentForm />
         </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditStudents;
